import React, { useLayoutEffect, useEffect } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import About from "./pages/about/About";
import Cars from "./pages/cars/Cars";
import Contact from "./pages/contact/Contact";
import Hire from "./pages/Hire/Hire";
import Home from "./pages/home/Home";
import { GlobalStyles } from "./styles/GlobalStyles";
import AOS from "aos";
import "aos/dist/aos.css";

const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

export function App() {
  useEffect(() => {
    AOS.init({
      // once: true,
    });
    AOS.refresh();
  }, []);
  return (
    <>
      <GlobalStyles />
      <BrowserRouter>
        <Wrapper>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/sobre-nosotros" element={<About />}></Route>
            <Route path="/flota" element={<Cars />}></Route>
            <Route path="/como-contratarnos" element={<Hire />}></Route>
            <Route path="/contacto" element={<Contact />}></Route>
            <Route
              path="/*"
              element={<Navigate replace={true} to="/" />}
            ></Route>
          </Routes>
        </Wrapper>
      </BrowserRouter>
    </>
  );
}

export default App;
